"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFilterableListContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-useless-escape */
const app_1 = require("app");
const React = require("react");
const actions_1 = require("src/actions");
const search_1 = require("src/search");
const webexUI_1 = require("webexUI");
const index_1 = require("../../Pages/index");
const FilterTypings_1 = require("../Filters/FilterTypings");
const FilterableList_1 = require("./FilterableList");
const FilterableListService_1 = require("./FilterableListService");
const ZeroResultsContainer_1 = require("./ZeroResultsContainer");
const search_2 = require("src/search");
class BaseFilterableListContainer extends React.Component {
    constructor(props) {
        super(props);
        this.onQueryChange = ({ query, isInitialSearch }) => {
            app_1.UrlService.AddToUrl({
                key: 'query',
                value: query,
            }, true);
            if (isInitialSearch) {
                app_1.UrlService.AddToUrl({
                    key: 'isInitialSearch',
                    value: 'true',
                }, true);
            }
            this.requestLoadData({ query });
        };
        this.onPageChange = (pageChangeParams) => {
            this.requestLoadData({ pageNumber: pageChangeParams.pageNumber }, pageChangeParams.filterChanged);
        };
        this.onPageSizeChange = (pageChangeParams) => {
            this.requestLoadData({ pageSize: pageChangeParams.pageSize }, pageChangeParams.filterChanged);
        };
        this.defaultType = (newSelectedFilters, groupValue, filterValue, filters, unSelect, isSub) => {
            if (filters[groupValue].newSearchGuiType === FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti && unSelect) {
                if (!isSub) {
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: [] });
                    return newSelectedFilters;
                }
                newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: filters[groupValue].items
                        .filter(item => item.title.indexOf('@') === -1 && item.selected)
                        .map(item => item.value) });
                return newSelectedFilters;
            }
            newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: newSelectedFilters[groupValue].indexOf(filterValue) === -1
                    ? [...newSelectedFilters[groupValue], filterValue]
                    : newSelectedFilters[groupValue].filter(item => item !== filterValue) });
            if (search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias === groupValue ||
                search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias === groupValue) {
                const filter = filters[groupValue].items.filter(item => item.value === filterValue)[0];
                const childrenValues = filters[groupValue].items
                    .filter(item => item.title.indexOf(`${filter.title}@`) > -1)
                    .map(item => item.value);
                if (filter.selected && childrenValues.length > 0) {
                    newSelectedFilters[groupValue] = newSelectedFilters[groupValue].filter(item => childrenValues.indexOf(item) === -1);
                }
            }
            return newSelectedFilters;
        };
        this.isFilterValue = filterValue => {
            return filterValue && filterValue.length ? [filterValue] : [];
        };
        this.isPreparedFilters = (preparedFilters, filters) => {
            return preparedFilters ? preparedFilters.filters : Object.assign({}, filters);
        };
        this.isPreparedSelectedFilters = (preparedFilters, selectedFilters) => {
            return preparedFilters ? preparedFilters.selectedFilters : Object.assign({}, selectedFilters);
        };
        this.isNullUnSelect = unSelect => {
            if (!unSelect) {
                return;
            }
        };
        this.onFilterChange = (data) => {
            const { filters, selectedFilters } = this.state;
            const { filterValue, groupValue, unSelect, isSub } = data;
            let preparedFilters;
            if (this.props.prepareChangedFiltersHandler) {
                preparedFilters = this.props.prepareChangedFiltersHandler(groupValue, filterValue, filters, selectedFilters, unSelect);
            }
            const newFilters = this.isPreparedFilters(preparedFilters, filters);
            let newSelectedFilters = this.isPreparedSelectedFilters(preparedFilters, selectedFilters);
            switch (filters[groupValue].guiType) {
                case FilterTypings_1.FilterGroupGuiTypeEnum.Radio:
                    if (selectedFilters[groupValue].indexOf(filterValue) > -1) {
                        this.isNullUnSelect(unSelect);
                        newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: [] });
                        break;
                    }
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: [filterValue] });
                    break;
                case FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown:
                case FilterTypings_1.FilterGroupGuiTypeEnum.Autosuggest:
                case FilterTypings_1.FilterGroupGuiTypeEnum.Textbox:
                case FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy:
                    if (unSelect) {
                        newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: [] });
                        break;
                    }
                    if (selectedFilters[groupValue].indexOf(filterValue) > -1 ||
                        (selectedFilters[groupValue].length === 0 && filterValue === '')) {
                        return;
                    }
                    newSelectedFilters = Object.assign(Object.assign({}, newSelectedFilters), { [groupValue]: newSelectedFilters[groupValue].indexOf(filterValue) === -1 &&
                            this.isFilterValue(filterValue) });
                    break;
                default:
                    newSelectedFilters = this.defaultType(newSelectedFilters, groupValue, filterValue, filters, unSelect, isSub);
            }
            const sortBy = this.getSortingValueDependOnSelectedFilters(newSelectedFilters);
            this.requestLoadData({
                filters: newFilters ? newFilters : filters,
                pageNumber: -1,
                selectedFilters: newSelectedFilters,
                status: { statusCode: FilterableList_1.ListStatusCode.inProgress },
                sortBy,
            }, true);
        };
        this.requestLoadData = (changedState = null, filterChange = false) => {
            const urlObj = app_1.UrlService.GetObjectFromUrlString();
            const isInitialSearch = !!urlObj.isInitialSearch;
            const performLoadData = () => {
                const { selectedFilters, sortBy, query, pageNumber, pageSize } = this.state;
                const selectedFiltersList = this.getSelectedFiltersList(selectedFilters);
                const filters = {
                    sortBy,
                    query,
                };
                this.loadData(selectedFiltersList, pageNumber, pageSize, filters, filterChange, null, true, isInitialSearch);
            };
            if (changedState) {
                this.setState(changedState, performLoadData);
            }
            else {
                performLoadData();
            }
        };
        this.onSearchQueryChange = () => {
            // change query (type another search) - subsequent search
            const urlObj = app_1.UrlService.GetObjectFromUrlString();
            const isInitialSearch = !!urlObj.isInitialSearch;
            const filters = {
                sortBy: '',
                query: urlObj.query,
            };
            this.loadData([], -1, 10, filters, null, { subsequent: true }, false, isInitialSearch);
        };
        this.onSortChange = (sortBy) => {
            this.requestLoadData({
                pageNumber: -1,
                sortBy,
            });
        };
        this.loadData = (selectedFiltersList, pageNumber, pageSize, filters, filterChange = false, search, returnStateInsteadOfSet = false, isInitialSearch) => {
            const { dataLoader, zeroResultGuard } = this.props;
            if (zeroResultGuard && zeroResultGuard()) {
                this.setState({ showZeroResultView: true });
                return;
            }
            dataLoader
                .loadData(selectedFiltersList, pageNumber, pageSize, filters.sortBy, filters.query, filterChange, search, isInitialSearch)
                .then((result) => {
                const { filteredData, initialData, selectedFilters } = result;
                const { totalItems } = filteredData;
                const pageCount = this.getPageCount(totalItems, pageSize);
                if (totalItems && !this.isURLPageNumberValid(pageNumber, pageCount)) {
                    return this.loadData(selectedFiltersList, 0, pageSize, {
                        sortBy: filters.sortBy,
                        query: filters.query,
                    });
                }
                this.setNextState(filteredData, initialData, pageNumber, pageSize, selectedFilters, filters.sortBy, filters.query);
                app_1.ComponentService.UpdateComponentsSelector();
            })
                .catch(() => {
                this.revertState();
            });
            if (returnStateInsteadOfSet) {
                return { waitingForResults: true };
            }
            this.setState({ waitingForResults: true });
        };
        this.isURLPageNumberValid = (pageNumber, pageCount) => pageNumber < pageCount;
        this.getFiltersFromUrlAndLoadData = () => {
            // load search page - first search
            const filtersFromUrl = FilterableListService_1.FilterableListService.getFiltersFromUrl();
            filtersFromUrl.pageSize = this.validateURLPageSize(filtersFromUrl.pageSize);
            let search;
            if (this.props.renderIn === FilterTypings_1.BaseFilterableListParent.SearchResultsListContainer) {
                search = { subsequent: false };
            }
            const filters = {
                sortBy: filtersFromUrl.sortBy || this.state.sortBy,
                query: filtersFromUrl.query,
            };
            this.loadData(filtersFromUrl.filters, filtersFromUrl.pageNumber, filtersFromUrl.pageSize, filters, null, search, false, !!filtersFromUrl.isInitialSearch);
        };
        this.validateURLPageSize = (pageSize) => {
            if (pageSize !== 5 && pageSize !== 10 && pageSize !== 15) {
                return 10;
            }
            return pageSize;
        };
        this.onFilterReset = () => {
            const { selectedFilters } = this.state;
            this.requestLoadData({
                pageNumber: 0,
                selectedFilters: Object.keys(selectedFilters).reduce((p, n) => (Object.assign(Object.assign({}, p), { [n]: [] })), {}),
            }, true);
        };
        this.onTabFilterReset = () => {
            const { selectedFilters } = this.state;
            this.requestLoadData({
                pageNumber: 0,
                selectedFilters: Object.keys(selectedFilters).reduce((acc, curr) => {
                    return Object.assign(Object.assign({}, acc), { [curr]: curr === search_1.FullTextSearchFilters.TypeFilterAlias ? selectedFilters[curr] : [] });
                }, {}),
                sortBy: '',
            }, true);
        };
        this.transformFilters = (filters) => {
            const filtersWithoutNulls = filters.reduce((acc, n) => {
                if (n) {
                    acc.push(n);
                }
                return acc;
            }, []);
            const filterGroupsOrder = filtersWithoutNulls.map(filterGroup => filterGroup.value);
            const transformedfilters = filtersWithoutNulls.reduce((acc, n) => {
                return Object.assign(Object.assign({}, acc), { [n.value]: n });
            }, {});
            return { filterGroupsOrder, filters: transformedfilters };
        };
        this.revertState = () => {
            this.setState(prevState => ({
                selectedFilters: this.getSelectedFiltersFromFilters(prevState.filterGroupsOrder, prevState.filters),
                waitingForResults: false,
            }));
        };
        this.onFilterCancel = (previousSelectedFilters) => {
            this.requestLoadData({
                pageNumber: -1,
                selectedFilters: previousSelectedFilters,
            }, true);
        };
        this.getSelectedFiltersFromFilters = (filterGroupsOrder, filters, selectedFiltersList = []) => {
            return filterGroupsOrder.reduce((acc, currentValue) => {
                const selectedFilters = [];
                if (filters[currentValue].guiType === FilterTypings_1.FilterGroupGuiTypeEnum.Autosuggest ||
                    filters[currentValue].guiType === FilterTypings_1.FilterGroupGuiTypeEnum.Textbox) {
                    const selectedAutosuggestValue = this.getFilterValueByGroup(currentValue, selectedFiltersList);
                    if (selectedAutosuggestValue) {
                        selectedFilters.push(selectedAutosuggestValue);
                    }
                }
                (0, webexUI_1.safe)(filters[currentValue].items).forEach(filterItem => {
                    if (filterItem.selected) {
                        selectedFilters.push(filterItem.value);
                    }
                });
                acc[currentValue] = selectedFilters;
                return acc;
            }, {});
        };
        this.getFilterValueByGroup = (groupName, filters) => {
            for (const filter of filters) {
                const currentFilter = filter && filter.split(':');
                if (currentFilter && currentFilter.length > 1 && currentFilter[0] === groupName) {
                    return filter;
                }
            }
            return null;
        };
        this.getSelectedFiltersList = (selectedFilters) => {
            let selectedFiltersList = [];
            Object.keys(selectedFilters).forEach(groupValue => {
                selectedFiltersList = [...selectedFiltersList, ...selectedFilters[groupValue]];
            });
            return selectedFiltersList;
        };
        this.initialLoad = () => {
            this.getFiltersFromUrlAndLoadData();
            if (this.props.defaultCountryPromise) {
                this.props.defaultCountryPromise
                    .then(countryCode => {
                    if (!countryCode) {
                        throw new Error();
                    }
                    app_1.UrlService.AddFilterToUrl(countryCode);
                })
                    .then(() => {
                    return this.getFiltersFromUrlAndLoadData();
                });
            }
        };
        this.getSortingValueDependOnSelectedFilters = (selectedFilters) => {
            let sortBy = this.state.sortBy;
            const { type, downloadSoftwareType } = selectedFilters;
            if (!type && !downloadSoftwareType) {
                return sortBy;
            }
            const isDownloadTabSelected = (type === null || type === void 0 ? void 0 : type[0]) === search_2.FullTextSearchFilterTypeKeys.DOWNLOAD;
            const isDownloadSoftwareTypesOptionSelected = (downloadSoftwareType === null || downloadSoftwareType === void 0 ? void 0 : downloadSoftwareType.length) > 0;
            const shouldResetDownloadSorting = !this.props.isDocumentsSearchPage &&
                (!isDownloadTabSelected || !isDownloadSoftwareTypesOptionSelected);
            if (shouldResetDownloadSorting) {
                sortBy = '';
            }
            return sortBy;
        };
        this.state = {
            filterGroupsOrder: [],
            filters: {},
            items: [],
            pageCount: 0,
            pageNumber: -1,
            pageSize: -1,
            query: '',
            selectedFilters: {},
            selectedFiltersQueryString: '',
            sortBy: index_1.PageContext.sortBy || '',
            totalItems: -1,
            waitingForResults: false,
            showZeroResultView: props.zeroResultGuard && props.zeroResultGuard(),
        };
        this.subscribers = [
            { type: actions_1.FilterableListActions.QUERY_CHANGE, handler: this.onQueryChange },
            { type: actions_1.FilterableListActions.SORT_CHANGE, handler: this.onSortChange },
            { type: actions_1.FilterableListActions.PAGE_CHANGE, handler: this.onPageChange },
            { type: actions_1.FilterableListActions.PAGE_SIZE_CHANGE, handler: this.onPageSizeChange },
            { type: actions_1.FilterableListActions.CANCEL, handler: this.onFilterCancel },
            { type: actions_1.FilterableListActions.CHANGE, handler: this.onFilterChange },
            { type: actions_1.FilterableListActions.RESET, handler: this.onFilterReset },
            { type: actions_1.FilterableListActions.RESET_TAB_FILTERS, handler: this.onTabFilterReset },
        ];
    }
    componentDidMount() {
        if (this.props.isUnderDevelopment) {
            return;
        }
        this.initialLoad();
        this.loadData = (0, webexUI_1.debounce)(this.loadData, 200);
        window.addEventListener('searchQueryChange', this.onSearchQueryChange);
        window.addEventListener('popstate', this.getFiltersFromUrlAndLoadData);
        actions_1.ActionsController.subscribe(this.subscribers);
    }
    componentWillUnmount() {
        window.removeEventListener('searchQueryChange', this.onSearchQueryChange);
        window.removeEventListener('popstate', this.getFiltersFromUrlAndLoadData);
        actions_1.ActionsController.unSubscribe(this.subscribers);
    }
    render() {
        if (this.props.isUnderDevelopment) {
            return (0, jsx_runtime_1.jsx)("p", { style: { color: '#e2000f', padding: '0 15px' }, children: "This page is under development." });
        }
        const { isDocumentsSearchPage, additionalData, customViewComponent, isTitleHidden } = this.props;
        const { filterGroupsOrder, filters, selectedFilters, items, pageCount, pageNumber, pageSize, totalItems, waitingForResults, selectedFiltersQueryString, selectedFiltersCount, sortBy, zeroResultsMessage, status, suggestions, query, showZeroResultView, allResultsCount, } = this.state;
        if (!isDocumentsSearchPage && (showZeroResultView || allResultsCount === 0)) {
            return ((0, jsx_runtime_1.jsx)(ZeroResultsContainer_1.ZeroResultsContainer, { additionalData: additionalData, className: "filterable-list", selectedFiltersQueryString: selectedFiltersQueryString, waitingForResults: false, suggestions: suggestions }));
        }
        const isQuery = query ? ` \'${query}\'` : '';
        return customViewComponent ? (customViewComponent(this.state, this.props)) : ((0, jsx_runtime_1.jsx)(FilterableList_1.FilterableList, { query: query, title: index_1.PageContext.title + isQuery, filterGroupsOrder: filterGroupsOrder, filters: filters, selectedFilters: selectedFilters, selectedFiltersQueryString: selectedFiltersQueryString, selectedFiltersCount: selectedFiltersCount, pageCount: pageCount, pageSize: pageSize, pageNumber: pageNumber, totalItems: totalItems, items: items, waitingForResults: waitingForResults, sortBy: sortBy, status: status, isTitleHidden: isTitleHidden, zeroResultsMessage: zeroResultsMessage, additionalData: additionalData, suggestions: suggestions, isDocumentsSearchPage: isDocumentsSearchPage }));
    }
    setNextState(state, initialData, pageNumber, pageSize, selectedFiltersList, sortBy, query) {
        const { getSelectedFiltersCountWithouPreselected } = this.props;
        const { filterGroupsOrder, filters } = this.transformFilters((0, webexUI_1.safe)(state.filters));
        const selectedFilters = this.getSelectedFiltersFromFilters(filterGroupsOrder, filters, selectedFiltersList);
        const selectedFiltersCount = getSelectedFiltersCountWithouPreselected
            ? getSelectedFiltersCountWithouPreselected(selectedFiltersList)
            : selectedFiltersList.length;
        const nextState = Object.assign(Object.assign({}, state), { filterGroupsOrder,
            filters, pageCount: this.getPageCount(state.totalItems, state.pageSize), query,
            selectedFilters,
            selectedFiltersCount, selectedFiltersQueryString: FilterableListService_1.FilterableListService.getUrlFromFilters(selectedFiltersList), sortBy, waitingForResults: false, showZeroResultView: false });
        if (pageSize > 0 && pageSize < nextState.pageCount) {
            nextState.pageSize = pageSize;
            nextState.pageCount = this.getPageCount(state.totalItems, nextState.pageSize);
        }
        if (pageNumber > 0 && pageNumber < nextState.pageCount) {
            nextState.pageNumber = pageNumber;
        }
        else if (pageNumber >= nextState.pageCount) {
            nextState.pageNumber = nextState.pageCount - 1;
        }
        else {
            nextState.pageNumber = 0;
        }
        this.setState(nextState);
    }
    getPageCount(totalCount, pageSize) {
        return Math.ceil(totalCount / (pageSize || 10));
    }
}
exports.BaseFilterableListContainer = BaseFilterableListContainer;
